import config from './shoes.xml'

const weightStr = config.shoes.$.dropitem
const list = config.shoes.item

function getWeight(str) {
  const arr = str.split(',')
  const res = {}
  arr.forEach(item => {
    const temp = item.split(':')
    res[temp[0]] = parseInt(temp[1])
  })
  return res
}

function getShoes(list) {
  const weightObj = getWeight(weightStr)
  return list.map(item => {
    const shoe = item.$
    shoe.weight = weightObj[shoe.id] ? weightObj[shoe.id] : 0
    return shoe
  })
}

// 球鞋配置
export const shoes = getShoes(list)
